<template>
  <div class="o-pagelayout" id="start">
    <div class="c-topbar">
      <div class="c-topbar__left">
        <mtg-header-link></mtg-header-link>
      </div>
      <div class="c-topbar__right">
        <div class="c-topbar__actions"></div>
      </div>
    </div>
    <main class="o-main o-main--align-center o-main--no-topbar" id="main">
      <div class="c-bg-visual">
        <div class="c-bg-visual__alpha">
          <img class="c-bg-visual__alpha-img" src="images/layout/bg-visual-alpha.png" alt="" />
        </div>
        <div class="c-bg-visual__beta">
          <img class="c-bg-visual__beta-img" src="images/layout/bg-visual-beta.png" alt="" />
        </div>
      </div>
      <div class="o-main__content">
        <alert-modal v-if="showAlert" :showAlert="showAlert"></alert-modal>
        <slot />
      </div>
    </main>
    <footer-component />
  </div>
</template>
<script>
import FooterComponent from "../components/FooterComponent";
import MtgHeaderLink from "../components/layout/MtgHeaderLink";
import AlertModal from "../components/AlertModal";
export default {
  name: "PageNotFoundLayout",
  components: {
    MtgHeaderLink,
    FooterComponent,
    AlertModal
  },
  computed: {
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    }
  }
};
</script>
<style scoped></style>
